const PERMISSION_KEY= "personalize:portfolio_stock";
const PAGE_URL = {
    PORTFOLIO_STOCK_PAGE: "/admin/personalize/portfolio-stock"
}

export {PERMISSION_KEY, PAGE_URL}

